import { createGlobalStyle } from 'styled-components';
import theme from './theme';

export const GlobalStyle = createGlobalStyle`
    .clear:after {
        content: "";
        display: block;
        clear: both;
    }

    .pointer{
        cursor: pointer;
        user-select: none;
    }

    .pointer-select{
        cursor: pointer;
    }

    .un-select{
        user-select: none;
    }

    .align-center{
        display: inline-flex;
        align-items: center;
    }

    .f-s-12{
        font-size: 12px;
    }

    .f_s_12{
        font-size: 12px !important;
    }

    .f-s-16{
        font-size: 16px;
    }

    .f_s_16{
        font-size: 16px !important;
    }

    .m-l-10{
        margin-left: 10px;
    }

    .m-l-12{
        margin-left: 12px;
    }

    .m-l-20{
        margin-left: 20px;
    }

    .m-r-5{
        margin-right: 5px;
    }

    .m-r-10{
        margin-right: 10px;
    }

    .m_r_10{
        margin-right: 10px !important;
    }

    .m-r-12{
        margin-right: 12px;
    }

    .m-r-15{
        margin-right: 15px;
    }

    .m-r-20{
        margin-right: 20px;
    }

    .m-r-30 {
        margin-right: 30px;
    }

    .m-t-24 {
        margin-top: 24px;
    }

    .m_b_0{
        margin-bottom: 0px !important;
    }

    .m-b-5{
        margin-bottom: 5px;
    }
    
    .m-b-8{
        margin-bottom: 8px;
    }

    .m-b-10{
        margin-bottom: 10px;
    }

    .m_b_10{
        margin-bottom: 10px !important;
    }

    .m-b-15{
        margin-bottom: 15px;
    }

    .m-b-16{
        margin-bottom: 16px;
    }

    .m-b-20{
        margin-bottom: 20px;
    }

    .p-t-10{
        padding-top: 10px;
    }

    .p-l-10{
        padding-left: 10px;
    }

    .p-b-10{
        padding-bottom: 10px;
    }

    .text-left{
        text-align: left;
    }

    .text-right{
        text-align: right;
    }

    .text-center{
        text-align: center;
    }

    .float-left{
        float: left;
    }

    .float-right{
        float: right;
    }

    .color-8{
        color: #888;
    }

    .color-9{
        color: #999;
    }

    .color-red{
        color: ${theme.colorRed};
    }

    .width-70{
        width: 70px;
    }

    .width_70{
        width: 70px !important;
    }

    .width-80{
        width: 80px;
    }

    .width_80{
        width: 80px !important;
    }

    .width-100{
        width: 100px;
    }

    .width_100{
        width: 100px !important;
    }

    .width-full{
        width: 100%;
    }

    .width_full{
        width: 100% !important;
    }

    /* flex布局 */
    .flex{
        display: flex;

        /* 换行 */
        &.flex-wrap{
            flex-wrap: wrap;
        }

        /* 不换行 */
        &.flex-nowrap{
            flex-wrap: nowrap;
        }

        /* 垂直居中 */
        &.col-center{
            align-items: center;
        }

        /* 顶部对齐 */
        &.col-top {
            align-items: flex-start;
        }

        /* 底部对齐 */
        &.col-bottom {
            align-items: flex-end;
        }

        /* 左边对齐 */
        &.row-left {
            justify-content: flex-start;
        }

        /* 水平居中 */
        &.row-center {
            justify-content: center;
        }

        /* 右边对齐 */
        &.row-right {
            justify-content: flex-end;
        }

        /* 水平两端对齐，项目之间的间隔都相等 */
        &.row-between {
            justify-content: space-between;
        }

        /* 水平每个项目两侧的间隔相等，所以项目之间的间隔比项目与父元素两边的间隔大一倍 */
        &.row-around {
            justify-content: space-around;
        }
    }
`;
